export default "static/media/utils.0408975.svg"